exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-img-item-analyze>img{\n    width: 40px;\n    height: 40px;\n    margin-right: 3px;\n}\n.img-radius-analyze{\n    border-radius: 20px;\n}", ""]);

